const settings: ClientSettings = {
  name: "Seu Crédito",
  benefitCardName: "Cartão Benefício",
  theme: {
    token: {
      colorPrimary: "#042940",
      colorHighlight: "#9FC131",
    },
  },
  assets: {
    background: "/bg-seucredito.png",
    logo: "/logo-seucredito.png",
    logo_header: "/logo-seucredito.png",
    favicon: "/favicon-seucredito.svg",
    card: "/cartao_beneficio-seucredito.jpg",
    consignedCard: "/cartao_consignado-seucredito.jpg",
  },
  cardExclusiveTheme: {
    name: "Seu Crédito",
    theme: {
      token: {
        colorPrimary: "#042940",
        colorHighlight: "#9FC131",
      },
    },
    assets: {
      background: "/bg-seucredito.png",
      logo: "/logo-seucredito.png",
      logo_header: "/logo-seucredito.png",
      favicon: "/favicon-seucredito.svg",
    },
  },
};

export default settings;
